export default function injectStyle({ style, lazyStyle, }) {
    return {
        rehype: (p) => p.use(() => (tree, file) => {
            const styleText = typeof style === 'function' ? style(file.data) : style;
            if (!styleText)
                return;
            tree.children.unshift({
                type: 'element',
                tagName: 'style',
                properties: {},
                children: [
                    {
                        type: 'text',
                        value: styleText,
                    },
                ],
            });
        }),
        viewerEffect({ $el, result }) {
            (async () => {
                const styleText = await (lazyStyle === null || lazyStyle === void 0 ? void 0 : lazyStyle(result.data));
                if (!styleText)
                    return;
                const $style = document.createElement('style');
                $style.innerHTML = styleText;
                $el.appendChild($style);
            })();
        },
    };
}
